export const GET_INIT_SUCCESS = 'system/GET_INIT_SUCCESS';
export const GET_INIT_REQUEST = 'system/GET_INIT_REQUEST';



// WEBPACK FOOTER //
// ./src/app/containers/System/constants.js